import { render, staticRenderFns } from "./goldenTaxInvoicingDialog.vue?vue&type=template&id=2984fb0e&scoped=true"
import script from "./goldenTaxInvoicingDialog.vue?vue&type=script&lang=js"
export * from "./goldenTaxInvoicingDialog.vue?vue&type=script&lang=js"
import style0 from "./goldenTaxInvoicingDialog.vue?vue&type=style&index=0&id=2984fb0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984fb0e",
  null
  
)

export default component.exports